const actions = {
  FETCH_REQUEST_ATTACHMENTS: 'FETCH_REQUEST_ATTACHMENTS',
  REQUEST_ATTACHMENT_FOLDER_NAVIGATE: 'REQUEST_ATTACHMENT_FOLDER_NAVIGATE',
  REQUEST_ATTACHMENT_FOLDER_POP: 'REQUEST_ATTACHMENT_FOLDER_POP',
  REQUEST_ATTACHMENT_FOLDER_PUSH: 'REQUEST_ATTACHMENT_FOLDER_PUSH',
  SHOW_REQUEST_ATTACHMENTS: 'SHOW_REQUEST_ATTACHMENTS',
  SHOW_REQUEST_ATTACHMENTS_ERROR: 'SHOW_REQUEST_ATTACHMENTS_ERROR',
  SHOW_REQUEST_FOLDER_ATTACHMENTS: 'SHOW_REQUEST_FOLDER_ATTACHMENTS',
  SHOW_REQUEST_FOLDER_ATTACHMENTS_ERROR: 'SHOW_REQUEST_FOLDER_ATTACHMENTS_ERROR',
  TOGGLE_REQUEST_ATTACHMENT_COLUMN_ORDER_BY: 'TOGGLE_REQUEST_ATTACHMENT_COLUMN_ORDER_BY',
  TOGGLE_REQUEST_ATTACHMENT_SELECTED: 'TOGGLE_REQUEST_ATTACHMENT_SELECTED',
  TOGGLE_REQUEST_ATTACHMENT_TYPE_FILTER: 'TOGGLE_REQUEST_ATTACHMENT_TYPE_FILTER',
  TOGGLE_REQUEST_ATTACHMENTS_SELECTED: 'TOGGLE_REQUEST_ATTACHMENTS_SELECTED',
  UPDATE_REQUEST_ATTACHMENT_TEXT_FILTER: 'UPDATE_REQUEST_ATTACHMENT_TEXT_FILTER',
};

export const attachmentRequestReasons = {
  REQUESTED_BY_USER: 'requested_by_user',
  REQUIRED_AT_CREATION: 'required_at_creation',
  REQUIRED_AT_TRANSFER: 'required_at_transfer',
};

export default actions;
